import Transformer from '../transformer'
import { money } from '@/filters'

/**
 * @autor Andres Aguilar <andresyoshimar@gmail.com>
 */

export default class AffectedTransformer extends Transformer {
  static fetch(affected) {
    const aff = (affected.affected) ? affected.affected : affected

    return {
      id: aff.id,
      requisitionNumber: aff.requisition_number,
      sinisterNumber: aff.sinister,
      sinisterId: aff.sinister_roads.id,
      highway: aff.sinister_roads.highway,
      total: aff.invoice_price ? money(aff.invoice_price) : 0,
    }
  }

  static send(affected) {
    return {
      id: affected.id,
      requisition_number: affected.requisitionNumber,
      sinister: affected.sinisternumber,
      highway: affected.highway,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/AffectedTransformer.js